import { Box, NotFound, Text } from '@factorialco/deprecated-design-system'
import { isEmptyDocument } from 'datocms-structured-text-utils'
import { ItemIntegrationFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { SetupInformation } from 'modules/marketplace/components/Description/SetupInformation'

type SetupProps = {
  integration: ItemIntegrationFragment
}

const ExternalIntegrations = ({ integration }: SetupProps) => {
  const parsedSetupInformation = integration.setupInformation
    ? JSON.parse(integration.setupInformation)
    : null
  const hasIntegrationSetupInformation = !isEmptyDocument(parsedSetupInformation)

  if (!hasIntegrationSetupInformation)
    return (
      <NotFound
        title={`${integration.name} ${i18n.t('marketplace.integrations.setup')}`}
        description={i18n.t('marketplace.integrations.setup_error_description')}
      />
    )

  return (
    <Box height="full" style={{ width: '60vw' }} paddingBottom="s120">
      <Box flexDirection="row" alignItems="center" gap="s12">
        {integration?.logo?.url && <img width="64px" src={integration.logo.url} />}
        <Text.Header1>
          {integration.name} {i18n.t('marketplace.integrations.setup')}
        </Text.Header1>
      </Box>
      <SetupInformation id="2" data={integration.setupInformation || ''} />
    </Box>
  )
}

export default ExternalIntegrations
